module.exports = __webpack_public_path__ + "img/msg01.312bd422.png";